import styled from '@emotion/styled';
import { Link } from '@reach/router';
import { DropdownMenuItem } from 'react-magma-dom';

export const StyledDropdownMenuItem = styled(DropdownMenuItem)`
  font-size: 13px !important;
  font-weight: 600 !important;
  font-stretch: normal !important;
  font-style: normal !important;
  line-height: 1.5 !important;
  letter-spacing: normal !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  width: 180px !important;
  display: block !important;
`;

export const StyledDropdownMenuItemEmail = styled(DropdownMenuItem)`
  font-size: 10px !important;
  font-weight: 600 !important;
  font-stretch: normal !important;
  font-style: normal !important;
  line-height: 1.5 !important;
  letter-spacing: normal !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  width: 178px !important;
  display: block;
`;

export const StyledLink = styled(Link)`
  text-decoration: none;
`;
